import { useGetRolesQuery } from "@/src/graphql/generated/api/graphql";

export function usePaginatedRoles(
    page: number = 0,
    pageSize: number = 15,
    skip: boolean = false
) {
    {
        const { data, loading, error } = useGetRolesQuery({
            variables: {
                paginationInput: {
                    page,
                    pageSize,
                },
                filters: [],
                sorting: [],
            },
            skip,
            fetchPolicy: "no-cache",
        });

        const roles = data?.getRoles.rows || [];
        const count = data?.getRoles.pagination.totalCount || 0;

        return {
            loading,
            error,
            roles,
            count,
        };
    }
}
